export default __webpack_public_path__ + "static/media/rappitonecorto.c1af24f0.mp3";